<div class="popup-overlay" [class.record-details-open]="showRecordDetails">
  <div class="popup-container">
    <div class="popup-header">
      <div class="header-title-group">
        <div class="header-icon-badge">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
          </svg>
        </div>
        <div>
          <h2 id="popup-title">Lead Status Reminder</h2>
          <p class="header-subtitle">
            Update assigned leads to maintain accurate reporting
          </p>
        </div>
      </div>
      @if (showCloseButton) {
        <button class="close-btn" (click)="closePopup()" aria-label="Close">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      }
    </div>

    <div class="popup-content" (scroll)="onContentScroll($event)">
      <div class="leads-summary">
        @if (isLoadingLeads) {
          <!-- Shimmering Skeleton Loader Structure -->
          <div class="skeleton-container">
            <div class="skeleton-hero-cards">
              <div class="skeleton-card">
                <div class="skeleton-icon-pulse shimmer"></div>
                <div class="skeleton-body">
                  <div class="skeleton-line count-line shimmer"></div>
                  <div class="skeleton-line title-line shimmer"></div>
                </div>
              </div>
              <div class="skeleton-card">
                <div class="skeleton-icon-pulse shimmer"></div>
                <div class="skeleton-body">
                  <div class="skeleton-line count-line shimmer"></div>
                  <div class="skeleton-line title-line shimmer"></div>
                </div>
              </div>
            </div>

            <div class="skeleton-banner">
              <div class="skeleton-line banner-text-line shimmer"></div>
              <div class="skeleton-track shimmer"></div>
            </div>

            <div class="skeleton-leads-list">
              <div class="skeleton-lead-item">
                <div class="skeleton-info">
                  <div class="skeleton-line name-line shimmer"></div>
                  <div class="skeleton-line address-line shimmer"></div>
                  <div class="skeleton-line tag-line shimmer"></div>
                </div>
                <div class="skeleton-actions">
                  <div class="skeleton-select-pulse shimmer"></div>
                </div>
              </div>
              <div class="skeleton-lead-item">
                <div class="skeleton-info">
                  <div class="skeleton-line name-line shimmer"></div>
                  <div class="skeleton-line address-line shimmer"></div>
                  <div class="skeleton-line tag-line shimmer"></div>
                </div>
                <div class="skeleton-actions">
                  <div class="skeleton-select-pulse shimmer"></div>
                </div>
              </div>
            </div>
          </div>
        } @else if (pendingLeadsCount > 0) {
          <!-- Compact Hero Tab Switcher Cards -->
          <div class="hero-tab-cards" role="tablist">
            <!-- TAB 1 CARD: NO STATUS -->
            <div
              class="hero-tab-card no-status-card"
              [class.active]="activeTab === 'no_status'"
              (click)="setActiveTab('no_status')"
              role="tab"
              tabindex="0"
              [attr.aria-selected]="activeTab === 'no_status'"
              (keydown.enter)="setActiveTab('no_status')"
            >
              <div class="card-compact-icon">
                <!-- <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg> -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="#e11d48"
                  viewBox="0 0 640 640"
                >
                  <path
                    d="M431.2 476.5L163.5 208.8C141.1 240.2 128 278.6 128 320C128 426 214 512 320 512C361.5 512 399.9 498.9 431.2 476.5zM476.5 431.2C498.9 399.8 512 361.4 512 320C512 214 426 128 320 128C278.5 128 240.1 141.1 208.8 163.5L476.5 431.2zM64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320z"
                  />
                </svg>
              </div>
              <div class="card-compact-body">
                <div class="card-title-line">
                  <span class="card-title">Leads with No Status</span>
                  @if (getNoStatusCompletedCount() > 0) {
                    <span class="card-updated-tag"
                      >✓ {{ getNoStatusCompletedCount() }} Selected</span
                    >
                  }
                </div>
                <span class="card-subtext"
                  >Assign initial status to move into active pipeline</span
                >
              </div>
              <div class="card-compact-count">
                <span class="card-count">{{ noStatusLeadsCount }}</span>
                <span class="count-label">No Status</span>
              </div>
              <div class="active-indicator"></div>
            </div>

            <!-- TAB 2 CARD: OUTDATED STATUS -->
            <div
              class="hero-tab-card outdated-card"
              [class.active]="activeTab === 'outdated'"
              (click)="setActiveTab('outdated')"
              role="tab"
              tabindex="0"
              [attr.aria-selected]="activeTab === 'outdated'"
              (keydown.enter)="setActiveTab('outdated')"
            >
              <div class="card-compact-icon">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
              </div>
              <div class="card-compact-body">
                <div class="card-title-line">
                  <span class="card-title">Outdated Lead Statuses</span>
                  @if (getOutdatedStatusCompletedCount() > 0) {
                    <span class="card-updated-tag"
                      >✓ {{ getOutdatedStatusCompletedCount() }} Selected</span
                    >
                  }
                </div>
                <span class="card-subtext"
                  >Refresh progress for leads not updated in &gt;7 days</span
                >
              </div>
              <div class="card-compact-count">
                <span class="card-count">{{ outdatedStatusLeadsCount }}</span>
                <span class="count-label">Outdated</span>
              </div>
              <div class="active-indicator"></div>
            </div>
          </div>

          <!-- Single Unified Rich Progress Banner -->
          <div class="single-progress-banner">
            <div class="banner-header">
              <div class="banner-text">
                <p>
                  @if (activeTab === "no_status") {
                    Assign initial status to leads without a status below.
                  } @else {
                    Update progress for leads not updated in over 7 days.
                  }
                </p>
              </div>
              <div class="banner-metrics">
                <span class="metrics-count">
                  @if (activeTab === "no_status") {
                    <strong>{{ getNoStatusCompletedCount() }}</strong> of
                    <strong>{{ noStatusLeadsCount }}</strong> Updated
                  } @else {
                    <strong>{{ getOutdatedStatusCompletedCount() }}</strong> of
                    <strong>{{ outdatedStatusLeadsCount }}</strong> Updated
                  }
                </span>
                <span class="metrics-percent">
                  {{
                    activeTab === "no_status"
                      ? getNoStatusProgressPercentage()
                      : getOutdatedStatusProgressPercentage()
                  }}%
                </span>
              </div>
            </div>
            <div class="banner-progress-track">
              <div
                class="banner-progress-fill"
                [style.width.%]="
                  activeTab === 'no_status'
                    ? getNoStatusProgressPercentage()
                    : getOutdatedStatusProgressPercentage()
                "
              ></div>
            </div>
          </div>

          <!-- Tab Panels -->
          <div class="tab-panels">
            <!-- NO STATUS TAB -->
            @if (activeTab === "no_status") {
              <div class="pane-content">
                @if (noStatusLeads.length > 0) {
                  <div class="leads-list">
                    @for (lead of noStatusLeads; track lead.unique_id) {
                      <div
                        class="lead-item"
                        [class.lead-item-modified]="
                          statusChanges.has(lead.unique_id)
                        "
                      >
                        <div
                          class="lead-info clickable"
                          (click)="openRecordDetails(lead.unique_id)"
                          (keydown.enter)="openRecordDetails(lead.unique_id)"
                          (keydown.space)="openRecordDetails(lead.unique_id)"
                          tabindex="0"
                          role="button"
                          [attr.aria-label]="
                            'View details for ' + lead.company_name
                          "
                          title="Click to view lead details"
                        >
                          <div class="lead-name">
                            <span>{{ lead.company_name }}</span>
                            @if (statusChanges.has(lead.unique_id)) {
                              <span class="modified-badge"
                                >✓ Status Selected</span
                              >
                            }
                          </div>
                          <div class="lead-details">
                            @if (lead.short_address) {
                              <span class="lead-address">
                                <svg
                                  width="12"
                                  height="12"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                >
                                  <path
                                    d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                                  ></path>
                                  <circle cx="12" cy="10" r="3"></circle>
                                </svg>
                                {{ lead.short_address }}
                              </span>
                            }
                            <span class="lead-assigned">
                              Assigned to:
                              <strong
                                >{{ lead.assigned_to?.first_name }}
                                {{ lead.assigned_to?.last_name }}</strong
                              >
                            </span>
                            <span class="lead-status-info no-status">
                              Current Status: <em>None</em>
                            </span>
                          </div>
                        </div>
                        <div class="lead-actions">
                          <div class="select-wrapper">
                            <select
                              (change)="onStatusChange(lead.unique_id, $event)"
                              class="status-select"
                              [class.has-selection]="
                                statusChanges.has(lead.unique_id)
                              "
                              (click)="$event.stopPropagation()"
                              [ngModel]="getSelectedStatusValue(lead)"
                            >
                              <option value="" disabled>
                                Select New Status
                              </option>
                              @for (status of leadStatusOptions; track status) {
                                <option [value]="status.value">
                                  {{ status.option }}
                                </option>
                              }
                            </select>
                          </div>

                          @if (isFundedStatus(getSelectedStatusValue(lead))) {
                            @let error = getApprovedAmountError(lead);

                            <div class="input-wrapper">
                              <input
                                type="number"
                                class="approved-amount-input"
                                [ngClass]="{ invalid: error }"
                                [placeholder]="getApprovedAmountLabel(lead)"
                                [(ngModel)]="
                                  approvedLoanAmounts[lead.unique_id]
                                "
                                (click)="$event.stopPropagation()"
                                min="1"
                              />
                            </div>

                            @if (error) {
                              <div class="error-message">
                                {{ error }}
                              </div>
                            }
                          }
                        </div>
                      </div>
                    }
                  </div>

                  <!-- Lazy Loading / Infinite Scroll Triggers -->
                  <div class="lazy-load-footer">
                    @if (isLoadingMoreNoStatus) {
                      <div class="lazy-load-spinner">
                        <span class="loading-spinner-sm"></span>
                        <span>Loading more leads...</span>
                      </div>
                    } @else if (hasMoreNoStatusLeads) {
                      <button
                        type="button"
                        class="btn-load-more"
                        (click)="loadMoreNoStatusLeads()"
                      >
                        Load More Leads (Showing {{ noStatusLeads.length }} of
                        {{ noStatusLeadsCount }})
                      </button>
                    } @else {
                      <span class="all-loaded-text"
                        >Showing all {{ noStatusLeadsCount }} leads</span
                      >
                    }
                  </div>
                } @else {
                  <div class="empty-state">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                    >
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                      <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                    <p>No leads without status found.</p>
                  </div>
                }
              </div>
            }

            <!-- OUTDATED STATUS TAB -->
            @if (activeTab === "outdated") {
              <div class="pane-content">
                @if (outdatedStatusLeads.length > 0) {
                  <div class="leads-list">
                    @for (lead of outdatedStatusLeads; track lead.unique_id) {
                      <div
                        class="lead-item"
                        [class.lead-item-modified]="
                          statusChanges.has(lead.unique_id)
                        "
                      >
                        <div
                          class="lead-info clickable"
                          (click)="openRecordDetails(lead.unique_id)"
                          (keydown.enter)="openRecordDetails(lead.unique_id)"
                          (keydown.space)="openRecordDetails(lead.unique_id)"
                          tabindex="0"
                          role="button"
                          [attr.aria-label]="
                            'View details for ' + lead.company_name
                          "
                          title="Click to view lead details"
                        >
                          <div class="lead-name">
                            <span>{{ lead.company_name }}</span>
                            @if (statusChanges.has(lead.unique_id)) {
                              <span class="modified-badge"
                                >✓ Status Selected</span
                              >
                            }
                          </div>
                          <div class="lead-details">
                            @if (lead.short_address) {
                              <span class="lead-address">
                                <svg
                                  width="12"
                                  height="12"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                >
                                  <path
                                    d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                                  ></path>
                                  <circle cx="12" cy="10" r="3"></circle>
                                </svg>
                                {{ lead.short_address }}
                              </span>
                            }
                            <span class="lead-assigned">
                              Assigned to:
                              <strong
                                >{{ lead.assigned_to?.first_name }}
                                {{ lead.assigned_to?.last_name }}</strong
                              >
                            </span>
                            <span class="lead-status-info outdated">
                              Status:
                              <strong>{{
                                getStatusDisplayValue(lead.lead_status)
                              }}</strong>
                              <span class="date-pill"
                                >Updated
                                {{
                                  formatDate(lead.lead_status_updated_on_utc)
                                }}</span
                              >
                            </span>
                          </div>
                        </div>
                        <div class="lead-actions">
                          <div class="select-wrapper">
                            <select
                              (change)="onStatusChange(lead.unique_id, $event)"
                              class="status-select"
                              [class.has-selection]="
                                statusChanges.has(lead.unique_id)
                              "
                              (click)="$event.stopPropagation()"
                              [ngModel]="getSelectedStatusValue(lead)"
                            >
                              <option value="" disabled>
                                Select New Status
                              </option>
                              @for (status of leadStatusOptions; track status) {
                                <option [value]="status.value">
                                  {{ status.option }}
                                </option>
                              }
                            </select>
                          </div>
                          @if (isFundedStatus(getSelectedStatusValue(lead))) {
                            @let error = getApprovedAmountError(lead);

                            <div class="input-wrapper">
                              <input
                                type="number"
                                class="approved-amount-input"
                                [ngClass]="{ invalid: error }"
                                [placeholder]="getApprovedAmountLabel(lead)"
                                [(ngModel)]="
                                  approvedLoanAmounts[lead.unique_id]
                                "
                                (click)="$event.stopPropagation()"
                                min="1"
                              />
                            </div>

                            @if (error) {
                              <div class="error-message">
                                {{ error }}
                              </div>
                            }
                          }
                        </div>
                      </div>
                    }
                  </div>

                  <!-- Lazy Loading / Infinite Scroll Triggers -->
                  <div class="lazy-load-footer">
                    @if (isLoadingMoreOutdated) {
                      <div class="lazy-load-spinner">
                        <span class="loading-spinner-sm"></span>
                        <span>Loading more leads...</span>
                      </div>
                    } @else if (hasMoreOutdatedStatusLeads) {
                      <button
                        type="button"
                        class="btn-load-more"
                        (click)="loadMoreOutdatedStatusLeads()"
                      >
                        Load More Leads (Showing
                        {{ outdatedStatusLeads.length }} of
                        {{ outdatedStatusLeadsCount }})
                      </button>
                    } @else {
                      <span class="all-loaded-text"
                        >Showing all {{ outdatedStatusLeadsCount }} leads</span
                      >
                    }
                  </div>
                } @else {
                  <div class="empty-state">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                    >
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                      <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                    <p>No outdated status leads found.</p>
                  </div>
                }
              </div>
            }
          </div>
        } @else if (!isLoadingLeads && pendingLeadsCount === 0) {
          <div class="empty-state">
            <svg
              width="36"
              height="36"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#10b981"
              stroke-width="2"
            >
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
            <p>All clear! No pending lead updates found.</p>
          </div>
        }
      </div>
    </div>

    <!-- Popup Footer Actions -->
    @if (!isLoadingLeads) {
      <div class="popup-actions">
        @if (showCloseButton) {
          <button
            class="btn btn-secondary close-btn-action"
            (click)="closePopup()"
            [disabled]="isNavigating || isSaving"
          >
            Cancel
          </button>
        } @else {
          <button
            class="btn btn-secondary"
            (click)="remindLater()"
            [disabled]="isNavigating || isSaving"
          >
            Remind Me Later
          </button>
        }

        <button
          class="btn btn-primary"
          (click)="saveChanges()"
          [disabled]="
            isSaving || statusChanges.size === 0 || hasFundedAmountErrors()
          "
        >
          @if (isSaving) {
            <span class="loading-spinner"></span>
            Saving Changes...
          } @else {
            Save Changes
            {{ statusChanges.size > 0 ? "(" + statusChanges.size + ")" : "" }}
          }
        </button>
      </div>
    }
  </div>
</div>

@if (showRecordDetails && selectedLeadUniqueId) {
  <app-record-details
    [unique_id]="selectedLeadUniqueId"
    (popupClosed)="onRecordDetailsClosed()"
    (assignedLead)="onAssignUnassignLead($event)"
    (leadStatusUpdated)="onLeadStatusUpdated($event)"
  ></app-record-details>
}
